import { deviceType } from "@tm/static/utils";
import { theme } from "@tm/utility/global";
import styled from "styled-components";

export const manageTitleStyle = {
  color: theme.blackText,
  fontSize: "18px",
  lineHeight: "22px",
  fontWeight: 900,
};

export const manageSubTitleStyle = {
  color: theme.greyText,
  fontSize: "13px",
  lineHeight: "18px",
  fontWeight: 400,
  margin: 0,
};

const CARD_GRADIENT_START = "#f7f4ff";
const CARD_GRADIENT_END = "#dceaff";

export const ManageInsuranceCard = styled.div`
  position: relative;
  overflow: hidden;
  background: linear-gradient(
      46.21deg,
      ${CARD_GRADIENT_START} 0.78%,
      ${CARD_GRADIENT_END} 97.21%
    ),
    ${theme.whiteText};
  border: 1px solid ${theme.whiteText};
  border-radius: 16px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media ${deviceType.mobile} {
    padding: 16px;
    gap: 10px;
  }
`;

export const ManageInsuranceIcon = styled.img`
  position: absolute;
  top: -8px;
  right: -8px;
  width: 104px;
  height: 104px;
  pointer-events: none;
  user-select: none;
`;

export const ManageInsuranceHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  z-index: 1;
  padding-right: 96px;

  @media ${deviceType.mobile} {
    padding-right: 80px;
  }
`;

export const ManageInsuranceActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 4px;
`;
